import { Component } from "solid-js";

interface HandBagsIconProps {
  class?: string;
}

export const HandBagsIcon: Component<HandBagsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0853 9.33331H7.91463C7.21197 9.33331 6.63063 9.82576 6.58397 10.4594L5.52263 24.8635C5.41997 26.2563 6.6413 27.438 8.18397 27.438H23.816C25.3586 27.438 26.58 26.2563 26.4773 24.8635L25.416 10.4594C25.3693 9.82576 24.788 9.33331 24.0853 9.33331Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0013 12V6.66669V6.66669V6.66669C20.0013 4.45735 18.2107 2.66669 16.0013 2.66669H16C13.7907 2.66669 12 4.45735 12 6.66669V6.66669V6.66669V12"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3334 16V17.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6667 16V17.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.6666 21.3333C20.6666 21.3333 18.9159 23.0826 15.9999 23.0826C13.0826 23.0826 11.3333 21.3333 11.3333 21.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
